import React, { useState } from 'react'
import {
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import TableRowsIcon from '@mui/icons-material/TableRows'
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined'

// Card wrapper for a chart with an accessible table-view twin —
// every plotted value stays reachable without relying on colour or hover
const ChartCard = ({
  title,
  subtitle,
  columns,
  rows,
  height = 240,
  children,
}) => {
  const [showTable, setShowTable] = useState(false)
  const hasTable = columns?.length > 0 && rows?.length > 0

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2.5, display: 'flex', flexDirection: 'column' }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={1.5}
      >
        <Stack>
          <Typography variant="title">{title}</Typography>
          {subtitle && <Typography variant="smallGrey">{subtitle}</Typography>}
        </Stack>
        {hasTable && (
          <Tooltip title={showTable ? 'Show chart' : 'View as table'}>
            <IconButton
              size="small"
              onClick={() => setShowTable((prev) => !prev)}
              aria-label={showTable ? 'Show chart' : 'View data as table'}
            >
              {showTable ? (
                <InsertChartOutlinedIcon fontSize="small" />
              ) : (
                <TableRowsIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {showTable && hasTable ? (
        <Box sx={{ height, overflowY: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={col} sx={{ fontSize: '0.78rem' }}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                <TableRow key={i}>
                  {row.map((cell, j) => (
                    <TableCell
                      key={j}
                      sx={{
                        fontSize: '0.8rem',
                        fontVariantNumeric: j > 0 ? 'tabular-nums' : undefined,
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      ) : (
        // chart.js needs a fixed-height parent — a flexible one triggers a
        // canvas resize loop
        <Box sx={{ height, position: 'relative' }}>{children}</Box>
      )}
    </Paper>
  )
}

export default ChartCard
